import { AxiosRequestConfig } from 'axios'
import { apiInstance } from '@shared/api'

type SilentRequestConfig = AxiosRequestConfig & {
  suppressGlobalErrorHandler: boolean
}

const silentRequestConfig: SilentRequestConfig = {
  suppressGlobalErrorHandler: true,
}

export const getAuthTerms = async () => {
  const res = await apiInstance.get<TermsResponse>('/api/v1/auth/terms/agree')
  return res.data
}

export const getAuthTermsArticles = async (needAgree: string[]) => {
  const termsType = needAgree[0] ?? 'exemption'
  const res = await apiInstance.get<TermsArticlesResponse>('/api/v1/auth/terms/articles', {
    params: { termsType },
  })
  return res.data
}

export const postAuthTermsAgreeBulk = async (body: TermsAgreeBulkRequest) => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/auth/terms/agree/bulk', body)
  return res.data
}

export const postAuthSignupCheck = async (body: SignupCheckRequest) => {
  const res = await apiInstance.post<ApiResponseBase>(
    '/api/v1/auth/signup/check',
    body,
    silentRequestConfig,
  )
  return res.data
}

export const postAuthSignup = async (body: SignupRequest, recaptchaToken?: string) => {
  const res = await apiInstance.post<SignupResponse>('/api/v1/auth/signup', body, {
    headers: recaptchaToken ? { 'Recapcha-Token': recaptchaToken } : {},
  })
  return res.data
}

export const postAuthSignupVerify = async (body: SignupVerifyRequest) => {
  const res = await apiInstance.post<ApiResponse>('/api/v1/auth/signup/verify', body)
  return res.data
}

export const postAuthLogin = async (body: LoginRequest, recaptchaToken?: string) => {
  const res = await apiInstance.post<LoginResponse>('/api/v1/auth/login', body, {
    ...silentRequestConfig,
    headers: recaptchaToken ? { 'Recapcha-Token': recaptchaToken } : {},
  })
  return res.data
}

export const getAuthSession = async () => {
  const res = await apiInstance.get<AuthSessionResponse>(
    '/api/v1/auth/session',
    silentRequestConfig,
  )
  return res.data
}

export const postAuthLogout = async () => {
  const res = await apiInstance.post<ApiResponse>('/api/v1/auth/logout')
  return res.data
}

export const postAuthPasswordResetRequest = async (body: PasswordResetRequestBody) => {
  const res = await apiInstance.post<PasswordResetRequestResponse>('/api/v1/auth/password/reset/request', body)
  return res.data
}

export const postAuthPasswordResetVerify = async (body: PasswordResetVerifyRequest) => {
  const res = await apiInstance.post<ApiResponse>('/api/v1/auth/password/reset/verify', body)
  return res.data
}

export const postAuthPasswordChange = async (body: PasswordChangeRequest) => {
  const res = await apiInstance.post<ApiResponse>('/api/v1/auth/password/change', body)
  return res.data
}

export const postAuthDeleteUserRequest = async () => {
  const res = await apiInstance.post<DeleteUserRequestResponse>('/api/v1/auth/deleteuser/request')
  return res.data
}

export const postAuthDeleteUserVerify = async (body: DeleteUserVerifyRequest) => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/auth/deleteuser/verify', body)
  return res.data
}
